const wrapper = "_mwwtfw1d7";
const header = "_mwhr9509o";
const contextMenu = "_mwcypu63i";
const contentWrapper = "_mwc1bygk1e";

export { contentWrapper, contextMenu, header, wrapper };
import "./_component.style.linaria.module.css";
//# sourceMappingURL=_component.style.js.map
